import { render, staticRenderFns } from "./MinStatementRow.vue?vue&type=template&id=68263426&"
import script from "./MinStatementRow.vue?vue&type=script&lang=js&"
export * from "./MinStatementRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports